import { useContext } from "react";
import { checkoutStripeCustomerPortal } from "../services/stripeService";
import useGetValidAccessToken from "./useGetValidAccessToken";
import { UserDetailsContext } from "../contexts";
import { toast } from "react-toastify";

interface ReturnType {
  getCustomerPortalLink: () => Promise<void>;
}


export const useGetCustomerPortalLink = ():ReturnType=>{
  const { stripeCustomerId } =useContext(UserDetailsContext);
    const { getValidAccessToken } = useGetValidAccessToken();


    const getCustomerPortalLink = async () => {
        if (!stripeCustomerId) return;
        try{
          const accessToken = await getValidAccessToken();
          await checkoutStripeCustomerPortal(stripeCustomerId, accessToken);
        }catch(er){
          toast.error("Unable to retrieve customer portal link");
        }
       
      };

    return {getCustomerPortalLink} 
}